import { FC, useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to top of page whenever path changes
const ScrollToTop: FC = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
};

export default ScrollToTop;
